module.exports = __webpack_public_path__ + "img/DasBoot.acf5673e.svg";